var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRelatorios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3C3C3B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12 14.167c1.078 0 1.953.874 1.953 1.953v8.49h0-3.906v-8.49c0-1.079.874-1.953 1.953-1.953zM12.786 6.667c1.08 0 1.954.874 1.954 1.953v15.99h0-3.907V8.62c0-1.079.875-1.953 1.953-1.953zM19.453 11.667c1.079 0 1.953.874 1.953 1.953v10.99h0H17.5V13.62c0-1.079.874-1.953 1.953-1.953z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.609 24.609L.391 24.609M.391.391L.391 24.609",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelatorios);
export default __webpack_public_path__ + "static/media/icon_relatorios.2381fc6bac4f2f53963090d88ec9a9a0.svg";
export { ForwardRef as ReactComponent };